import { faker } from '@faker-js/faker';
import { define } from 'cooky-cutter';
import { ItemFulfillment } from '../types';

export const itemFulfillmentFactory = define<ItemFulfillment>({
  id: () => faker.string.uuid(),
  number: () => faker.number.int({ max: 100000 }),
  externalId: () => faker.string.numeric({ length: 10 }),
});
